import { Slide } from "react-awesome-reveal";
import shape3 from "../../images/slider/shape3.svg";
import shape4 from "../../images/slider/shape4.svg";
import bgshape from "../../images/slider/bg-shape.png";

import Hashtag from "../Hashtag/Hashtag";
import { connect } from "react-redux";
import { capitalize } from "../../utils/string";
import { getCloudinaryFullPath } from "../../utils";
import BlessingsHeading from "../BlessingsHeading/BlessingsHeading";
import CoupleInfo from "../CoupleInfo/CoupleInfo";
import Lord from "../../images/Banner/lord-ganesh.png";
import CoupleHeading from "../CoupleHeading/CoupleHeading";

const TimelessCharmCoupleSection = ({
  couplePhoto,
  pathname,
  bride = {},
  groom = {},
}) => {
  return (
    <Slide direction="up" duration={2000} triggerOnce>
      <section
        className="wpo-couple-section-s10 static-hero-s10 wpo-story-section section-padding"
        id="couple"
        style={{ height: "auto" }}
      >
        <div className="container-fluid">
          <div className="center">
            <img
              style={{ height: 100 }}
              src={Lord}
              alt=""
            />
            <p
              className="namah-text"
              style={{
                marginBottom: "10px",
                fontSize: 14,
                marginTop: "5px",
              }}
            >|| Shree Ganeshay Namah ||</p>
            {groom.name.includes("Priyesh") && < p
              className="namah-text"
              style={{
                fontSize: 14,
                marginTop: "-10px",
              }}
            >|| Shree Sadguru Devay Namah ||</p>}
          </div>
          {pathname === "harshita-priyesh-2" ? <BlessingsHeading /> : <CoupleHeading />}
          <Hashtag />
          <div>
            <Slide direction="up" duration={1000} triggerOnce>
              <div className="text-grid" style={{ paddingBottom: "60px" }}>
                <CoupleInfo data={bride} isGroom={false} />
              </div>
            </Slide>
            <div className="static-hero-right">
              <div className="static-hero-img scene" id="scene">
                <div className="static-hero-img-inner">
                  <img
                    style={{ minHeight: "420px", objectFit: "cover" }}
                    src={getCloudinaryFullPath(couplePhoto)}
                    alt=""
                  />
                </div>
                <div className="static-hero-shape-1">
                  <span className="layer" data-depth="0.25">
                    <Slide direction="left" duration="1200" triggerOnce="true">
                      <img src={shape3} alt="" />
                    </Slide>
                  </span>
                </div>
                <div className="static-hero-shape-2">
                  <span className="layer" data-depth="0.45">
                    <Slide direction="right" duration="1200" triggerOnce="true">
                      <img src={shape4} alt="" />
                    </Slide>
                  </span>
                </div>
              </div>
              <div className="static-hero-img-bg">
                <img src={bgshape} alt="" style={{ height: "530px" }} />
              </div>
            </div>
            <Slide direction="up" duration={1000} triggerOnce>
              <div className="text-grid" style={{ paddingTop: "50px" }}>
                <CoupleInfo data={groom} isGroom={true} />
              </div>
            </Slide>
          </div>
        </div>
      </section>
    </Slide >
  );
};

const mapStateToProps = (state) => {
  return {
    bride: state.inviteDetails.invite?.bride,
    groom: state.inviteDetails.invite?.groom,
    couplePhoto: state.inviteDetails.invite?.couplePhoto,
    pathname: state.inviteDetails.invite?.pathname,
  };
};
export default connect(mapStateToProps)(TimelessCharmCoupleSection);
